var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRegisterSectionBuilding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1396,
    height: 225.612,
    viewBox: "0 0 1396 225.612",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17878",
    "data-name": "Group 17878",
    transform: "translate(1366)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17886",
    "data-name": "Group 17886",
    transform: "translate(-1366 85.624)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M238,64.321V47.789h-9.939V64.321H216.294V38.748h-8.631V19.632H200.6V0H185.955V19.632h-7.062V38.748h-8.369V15.757h-4.708V4.133h-2.877V15.757H146.2V89.12H133.385V81.37h-7.846v7.75H112.724v-24.8H89.708V47.789H79.77V64.321h-.523V96.094H68.785V77.5H56.231v18.6H45.77V38.748H37.662V19.632H7.846V38.748H0v101H249.771V64.321Z",
    transform: "translate(0)",
    fill: "#1ab1e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 10.914,
    height: 6.237,
    transform: "translate(4.937 45.596)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 10.914,
    height: 6.236,
    transform: "translate(29.742 45.596)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 10.914,
    height: 6.237,
    transform: "translate(4.937 57.983)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 10.914,
    height: 6.236,
    transform: "translate(29.742 57.983)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 10.914,
    height: 6.237,
    transform: "translate(4.937 70.37)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 10.914,
    height: 6.236,
    transform: "translate(29.742 70.37)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 10.914,
    height: 6.237,
    transform: "translate(4.937 82.758)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 10.914,
    height: 6.236,
    transform: "translate(29.742 82.758)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 10.914,
    height: 6.237,
    transform: "translate(4.937 95.145)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 10.914,
    height: 6.236,
    transform: "translate(29.742 95.145)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 10.914,
    height: 6.237,
    transform: "translate(4.937 107.532)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 10.914,
    height: 6.236,
    transform: "translate(29.742 107.532)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 10.914,
    height: 6.237,
    transform: "translate(4.937 119.835)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 10.914,
    height: 6.236,
    transform: "translate(29.742 119.835)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 25.466,
    height: 3.118,
    transform: "translate(49.898 104.344)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 25.466,
    height: 3.118,
    transform: "translate(49.898 109.087)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 25.466,
    height: 3.118,
    transform: "translate(49.898 113.691)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 25.466,
    height: 3.118,
    transform: "translate(116.837 105.925)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 25.466,
    height: 3.118,
    transform: "translate(116.837 110.668)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 25.466,
    height: 3.118,
    transform: "translate(116.837 115.282)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 25.466,
    height: 3.118,
    transform: "translate(49.898 118.463)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 25.466,
    height: 3.118,
    transform: "translate(49.898 123.235)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 25.466,
    height: 3.118,
    transform: "translate(49.898 128.006)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 7.016,
    height: 9.095,
    transform: "translate(84.886 71.705)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 7.016,
    height: 9.095,
    transform: "translate(100.307 71.705)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 7.016,
    height: 9.095,
    transform: "translate(84.886 86.468)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 7.016,
    height: 9.095,
    transform: "translate(100.307 86.468)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 7.016,
    height: 9.095,
    transform: "translate(84.886 101.231)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 7.016,
    height: 9.095,
    transform: "translate(100.307 101.23)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    width: 7.016,
    height: 9.095,
    transform: "translate(84.886 115.9)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    width: 7.016,
    height: 9.095,
    transform: "translate(100.307 115.9)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 9.355,
    height: 11.953,
    transform: "translate(146.318 21.687)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 9.355,
    height: 11.953,
    transform: "translate(146.318 39.553)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    width: 9.355,
    height: 11.953,
    transform: "translate(146.318 56.956)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 9.355,
    height: 11.953,
    transform: "translate(146.318 74.359)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 9.355,
    height: 11.953,
    transform: "translate(146.318 91.762)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 9.355,
    height: 11.953,
    transform: "translate(146.318 109.044)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 34.82,
    height: 10.134,
    transform: "translate(176.362 46.929)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 34.82,
    height: 10.134,
    transform: "translate(176.492 69.075)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 34.82,
    height: 10.134,
    transform: "translate(176.622 91.221)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 34.82,
    height: 10.134,
    transform: "translate(176.752 113.263)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 4.677,
    height: 9.874,
    transform: "translate(7.796 25.573)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 11.693,
    height: 15.072,
    transform: "translate(238.077 71.742)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 11.693,
    height: 15.072,
    transform: "translate(238.077 93.897)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 11.693,
    height: 15.072,
    transform: "translate(238.077 115.995)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M335.074,150.3h-1.788a1.252,1.252,0,1,0,0-2.5H318.8a1.252,1.252,0,0,0,0,2.5h1.788a1.252,1.252,0,1,0,0,2.5h-2.5a1.252,1.252,0,1,0,0,2.5h14.482a1.252,1.252,0,1,0,0-2.5h2.5a1.252,1.252,0,1,0,0-2.5Z",
    transform: "translate(-265.775 -137.909)",
    fill: "#ebfaff",
    opacity: 0.247
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M581.074,271.3h-1.788a1.253,1.253,0,1,0,0-2.5H564.8a1.253,1.253,0,0,0,0,2.5h1.788a1.252,1.252,0,1,0,0,2.5h-2.5a1.252,1.252,0,1,0,0,2.5h14.482a1.252,1.252,0,1,0,0-2.5h2.5a1.252,1.252,0,1,0,0-2.5Z",
    transform: "translate(-447.46 -226.873)",
    fill: "#ebfaff",
    opacity: 0.247
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M1000.074,113.3h-1.788a1.252,1.252,0,1,0,0-2.5H983.8a1.253,1.253,0,0,0,0,2.5h1.788a1.252,1.252,0,1,0,0,2.5h-2.5a1.253,1.253,0,1,0,0,2.5h14.482a1.253,1.253,0,0,0,0-2.5h2.5a1.252,1.252,0,1,0,0-2.5Z",
    transform: "translate(-756.883 -110.523)",
    fill: "#ebfaff",
    opacity: 0.247
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M519.189,465.94l-.309.226A1.316,1.316,0,0,0,519.189,465.94Z",
    transform: "translate(-415.095 -372.106)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M520.119,466.88l-.309.226A1.319,1.319,0,0,0,520.119,466.88Z",
    transform: "translate(-415.782 -372.799)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M520.119,465.94l-.309.226A1.317,1.317,0,0,0,520.119,465.94Z",
    transform: "translate(-415.782 -372.106)",
    fill: "#ebfaff",
    opacity: 0.253
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17879",
    "data-name": "Group 17879",
    transform: "translate(-372.804)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27-2",
    "data-name": "Path 27",
    d: "M383.824,103.73V77.069H367.8V103.73h-18.98V62.488H334.9V31.661H323.509V0h-23.62V31.661H288.5V62.488H275V25.412h-7.592V6.665h-4.64V25.412H235.778V143.723H215.11v-12.5H202.457v12.5H181.789V103.73H144.672V77.069H128.644V103.73H127.8v51.24H110.929V124.976H90.684v29.994H73.812V62.488H60.737V31.661H12.654V62.488H0V225.374H402.8V103.73Z",
    transform: "translate(0)",
    fill: "#1ab1e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15-2",
    "data-name": "Rectangle 15",
    width: 17.601,
    height: 10.058,
    transform: "translate(7.962 73.532)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16-2",
    "data-name": "Rectangle 16",
    width: 17.601,
    height: 10.058,
    transform: "translate(65.566 83.59) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17-2",
    "data-name": "Rectangle 17",
    width: 17.601,
    height: 10.058,
    transform: "translate(7.962 93.509)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18-2",
    "data-name": "Rectangle 18",
    width: 17.601,
    height: 10.058,
    transform: "translate(65.566 103.567) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19-2",
    "data-name": "Rectangle 19",
    width: 17.601,
    height: 10.058,
    transform: "translate(7.962 113.486)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20-2",
    "data-name": "Rectangle 20",
    width: 17.601,
    height: 10.058,
    transform: "translate(65.566 123.544) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21-2",
    "data-name": "Rectangle 21",
    width: 17.601,
    height: 10.058,
    transform: "translate(7.962 133.463)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22-2",
    "data-name": "Rectangle 22",
    width: 17.601,
    height: 10.058,
    transform: "translate(65.566 143.521) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23-2",
    "data-name": "Rectangle 23",
    width: 17.601,
    height: 10.058,
    transform: "translate(7.962 153.44)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24-2",
    "data-name": "Rectangle 24",
    width: 17.601,
    height: 10.058,
    transform: "translate(65.566 163.498) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25-2",
    "data-name": "Rectangle 25",
    width: 17.601,
    height: 10.058,
    transform: "translate(7.962 173.417)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26-2",
    "data-name": "Rectangle 26",
    width: 17.601,
    height: 10.058,
    transform: "translate(65.566 183.475) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27-2",
    "data-name": "Rectangle 27",
    width: 17.601,
    height: 10.058,
    transform: "translate(7.962 193.258)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28-2",
    "data-name": "Rectangle 28",
    width: 17.601,
    height: 10.058,
    transform: "translate(65.566 203.315) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29-2",
    "data-name": "Rectangle 29",
    width: 41.068,
    height: 5.029,
    transform: "translate(80.47 168.275)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30-2",
    "data-name": "Rectangle 30",
    width: 41.068,
    height: 5.029,
    transform: "translate(80.47 175.924)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31-2",
    "data-name": "Rectangle 31",
    width: 41.068,
    height: 5.029,
    transform: "translate(80.47 183.349)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32-2",
    "data-name": "Rectangle 32",
    width: 41.068,
    height: 5.029,
    transform: "translate(188.422 170.825)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33-2",
    "data-name": "Rectangle 33",
    width: 41.068,
    height: 5.029,
    transform: "translate(188.422 178.474)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34-2",
    "data-name": "Rectangle 34",
    width: 41.068,
    height: 5.029,
    transform: "translate(188.422 185.914)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35-2",
    "data-name": "Rectangle 35",
    width: 41.068,
    height: 5.029,
    transform: "translate(80.47 191.045)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36-2",
    "data-name": "Rectangle 36",
    width: 41.068,
    height: 5.029,
    transform: "translate(80.47 198.74)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37-2",
    "data-name": "Rectangle 37",
    width: 41.068,
    height: 5.029,
    transform: "translate(80.47 206.436)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38-2",
    "data-name": "Rectangle 38",
    width: 11.315,
    height: 14.667,
    transform: "translate(136.896 115.638)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39-2",
    "data-name": "Rectangle 39",
    width: 11.315,
    height: 14.667,
    transform: "translate(173.08 130.306) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40-2",
    "data-name": "Rectangle 40",
    width: 11.315,
    height: 14.667,
    transform: "translate(136.896 139.446)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41-2",
    "data-name": "Rectangle 41",
    width: 11.315,
    height: 14.667,
    transform: "translate(173.08 154.113) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42-2",
    "data-name": "Rectangle 42",
    width: 11.315,
    height: 14.667,
    transform: "translate(136.896 163.254)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43-2",
    "data-name": "Rectangle 43",
    width: 11.315,
    height: 14.667,
    transform: "translate(173.08 177.921) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44-2",
    "data-name": "Rectangle 44",
    width: 11.315,
    height: 14.667,
    transform: "translate(136.896 186.912)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45-2",
    "data-name": "Rectangle 45",
    width: 11.315,
    height: 14.667,
    transform: "translate(173.08 201.579) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46-2",
    "data-name": "Rectangle 46",
    width: 15.086,
    height: 19.277,
    transform: "translate(235.966 34.974)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47-2",
    "data-name": "Rectangle 47",
    width: 15.086,
    height: 19.277,
    transform: "translate(235.966 63.786)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48-2",
    "data-name": "Rectangle 48",
    width: 15.086,
    height: 19.277,
    transform: "translate(235.966 91.852)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49-2",
    "data-name": "Rectangle 49",
    width: 15.086,
    height: 19.277,
    transform: "translate(235.966 119.919)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50-2",
    "data-name": "Rectangle 50",
    width: 15.086,
    height: 19.277,
    transform: "translate(235.966 147.985)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51-2",
    "data-name": "Rectangle 51",
    width: 15.086,
    height: 19.277,
    transform: "translate(235.966 175.855)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52-2",
    "data-name": "Rectangle 52",
    width: 56.155,
    height: 16.344,
    transform: "translate(284.418 75.682)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53-2",
    "data-name": "Rectangle 53",
    width: 56.155,
    height: 16.344,
    transform: "translate(284.627 111.397)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54-2",
    "data-name": "Rectangle 54",
    width: 56.155,
    height: 16.344,
    transform: "translate(284.837 147.112)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55-2",
    "data-name": "Rectangle 55",
    width: 56.155,
    height: 16.344,
    transform: "translate(285.047 182.658)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56-2",
    "data-name": "Rectangle 56",
    width: 7.543,
    height: 15.925,
    transform: "translate(12.572 41.241)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57-2",
    "data-name": "Rectangle 57",
    width: 18.858,
    height: 24.306,
    transform: "translate(383.946 115.697)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58-2",
    "data-name": "Rectangle 58",
    width: 18.858,
    height: 24.306,
    transform: "translate(383.946 151.428)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59-2",
    "data-name": "Rectangle 59",
    width: 18.858,
    height: 24.306,
    transform: "translate(383.946 187.065)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28-2",
    "data-name": "Path 28",
    d: "M346.283,151.833H343.4a2.02,2.02,0,1,0,0-4.036H320.045a2.02,2.02,0,0,0,0,4.036h2.883a2.02,2.02,0,1,0,0,4.036h-4.036a2.02,2.02,0,1,0,0,4.036h23.355a2.02,2.02,0,1,0,0-4.036h4.036a2.02,2.02,0,1,0,0-4.036Z",
    transform: "translate(-234.525 -131.852)",
    fill: "#ebfaff",
    opacity: 0.247
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29-2",
    "data-name": "Path 29",
    d: "M592.283,272.833H589.4a2.02,2.02,0,1,0,0-4.036H566.045a2.02,2.02,0,0,0,0,4.036h2.883a2.02,2.02,0,1,0,0,4.036h-4.036a2.02,2.02,0,1,0,0,4.036h23.355a2.02,2.02,0,1,0,0-4.036h4.036a2.02,2.02,0,1,0,0-4.036Z",
    transform: "translate(-376.804 -201.187)",
    fill: "#ebfaff",
    opacity: 0.247
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30-2",
    "data-name": "Path 30",
    d: "M1011.283,114.833H1008.4a2.02,2.02,0,1,0,0-4.036H985.045a2.02,2.02,0,0,0,0,4.036h2.883a2.02,2.02,0,1,0,0,4.036h-4.036a2.02,2.02,0,1,0,0,4.036h23.355a2.02,2.02,0,0,0,0-4.036h4.036a2.02,2.02,0,1,0,0-4.036Z",
    transform: "translate(-619.089 -110.357)",
    fill: "#ebfaff",
    opacity: 0.247
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31-2",
    "data-name": "Path 31",
    d: "M519.379,465.94c-.323.235-.5.365-.5.365A2.122,2.122,0,0,0,519.379,465.94Z",
    transform: "translate(-351.506 -314.615)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32-2",
    "data-name": "Path 32",
    d: "M520.309,466.88c-.323.235-.5.365-.5.365A2.129,2.129,0,0,0,520.309,466.88Z",
    transform: "translate(-352.044 -315.155)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33-2",
    "data-name": "Path 33",
    d: "M520.309,465.94c-.323.235-.5.365-.5.365A2.127,2.127,0,0,0,520.309,465.94Z",
    transform: "translate(-352.044 -314.615)",
    fill: "#ebfaff",
    opacity: 0.253
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(-205.039 139.362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29-3",
    "data-name": "Path 29",
    d: "M156.371,584.29s-20.385,12.3,17.193,31.234c0,0,8.286-15.37-.875-27.9a12.34,12.34,0,0,0-16.009-3.508Z",
    transform: "translate(-150.851 -530.283)",
    fill: "#01a09b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30-3",
    "data-name": "Path 30",
    d: "M173.08,588.3s17.444,13.348,16.957,31.493",
    transform: "translate(-167.036 -534.552)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31-3",
    "data-name": "Path 31",
    d: "M235.033,514.459s-6.388-21.688,1.2-37.65A34.248,34.248,0,0,0,239,455.318a57.614,57.614,0,0,0-3.042-10.1",
    transform: "translate(-211.005 -428.519)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32-3",
    "data-name": "Path 32",
    d: "M236.443,392.214c0,2.659-4.813,10.357-4.813,10.357s-4.813-7.708-4.813-10.357a4.813,4.813,0,1,1,9.624,0Z",
    transform: "translate(-206.783 -387.289)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33-3",
    "data-name": "Path 33",
    d: "M267.073,442.19c-1.445,2.232-9.673,6.085-9.673,6.085s.15-9.086,1.595-11.318a4.813,4.813,0,0,1,8.079,5.23Z",
    transform: "translate(-229.401 -422.296)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M260.721,534.263c-2.374,1.2-11.421.37-11.421.37s4.715-7.768,7.089-8.964a4.813,4.813,0,1,1,4.335,8.595Z",
    transform: "translate(-223.406 -488.76)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M243.8,608.777c-2.136,1.579-11.2,2.294-11.2,2.294s3.335-8.451,5.471-10.033a4.813,4.813,0,1,1,5.725,7.74Z",
    transform: "translate(-211.057 -543.868)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M213.962,464.768c1.906,1.851,10.789,3.77,10.789,3.77s-2.175-8.822-4.081-10.676a4.813,4.813,0,1,0-6.706,6.9Z",
    transform: "translate(-196.135 -438.17)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M191.326,548.553c2.374,1.2,11.421.37,11.421.37s-4.715-7.768-7.089-8.964a4.813,4.813,0,1,0-4.335,8.595Z",
    transform: "translate(-178.573 -499.272)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M185.868,635.937c2.136,1.579,11.2,2.294,11.2,2.294s-3.335-8.454-5.474-10.033a4.813,4.813,0,1,0-5.725,7.739Z",
    transform: "translate(-175.052 -563.42)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M236.443,392.214c0,2.659-4.813,10.357-4.813,10.357s-4.813-7.708-4.813-10.357a4.813,4.813,0,1,1,9.624,0Z",
    transform: "translate(-206.783 -387.289)",
    fill: "#93d502",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M267.073,442.19c-1.445,2.232-9.673,6.085-9.673,6.085s.15-9.086,1.595-11.318a4.813,4.813,0,0,1,8.079,5.23Z",
    transform: "translate(-229.401 -422.296)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M260.721,534.263c-2.374,1.2-11.421.37-11.421.37s4.715-7.768,7.089-8.964a4.813,4.813,0,1,1,4.335,8.595Z",
    transform: "translate(-223.406 -488.76)",
    fill: "#93d502",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M243.8,608.777c-2.136,1.579-11.2,2.294-11.2,2.294s3.335-8.451,5.471-10.033a4.813,4.813,0,1,1,5.725,7.74Z",
    transform: "translate(-211.057 -543.868)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M213.962,464.768c1.906,1.851,10.789,3.77,10.789,3.77s-2.175-8.822-4.081-10.676a4.813,4.813,0,1,0-6.706,6.9Z",
    transform: "translate(-196.135 -438.17)",
    fill: "#5ec5c1",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M191.326,548.553c2.374,1.2,11.421.37,11.421.37s-4.715-7.768-7.089-8.964a4.813,4.813,0,1,0-4.335,8.595Z",
    transform: "translate(-178.573 -499.272)",
    fill: "#93d502",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M185.868,635.937c2.136,1.579,11.2,2.294,11.2,2.294s-3.335-8.454-5.474-10.033a4.813,4.813,0,1,0-5.725,7.739Z",
    transform: "translate(-175.052 -563.42)",
    opacity: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(-101.704 110.386)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M1005.926,516.043s-8.529-28.959,1.6-50.273a45.729,45.729,0,0,0,3.7-28.7,76.923,76.923,0,0,0-4.062-13.484",
    transform: "translate(-985.768 -401.127)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M1009.761,372.236c0,3.551-6.427,13.829-6.427,13.829s-6.427-10.293-6.427-13.829a6.427,6.427,0,1,1,12.851,0Z",
    transform: "translate(-982.062 -365.66)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M1040.367,422.506c-1.929,2.98-12.917,8.125-12.917,8.125s.2-12.132,2.13-15.112a6.427,6.427,0,1,1,10.787,6.984Z",
    transform: "translate(-1002.047 -395.944)",
    fill: "#5ec5c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M1034.61,515.688c-3.17,1.6-15.25.494-15.25.494s6.3-10.372,9.466-11.969a6.427,6.427,0,1,1,5.788,11.476Z",
    transform: "translate(-996.754 -454.924)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M1017.609,590.058c-2.852,2.109-14.95,3.063-14.95,3.063s4.453-11.285,7.305-13.4a6.427,6.427,0,0,1,7.644,10.334Z",
    transform: "translate(-985.827 -503.383)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M984.732,446.111c2.545,2.472,14.407,5.034,14.407,5.034s-2.9-11.779-5.449-14.255a6.428,6.428,0,1,0-8.958,9.221Z",
    transform: "translate(-972.823 -410.603)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M962.583,530.116c3.17,1.6,15.251.494,15.251.494s-6.3-10.372-9.466-11.969a6.427,6.427,0,0,0-5.784,11.475Z",
    transform: "translate(-957.387 -464.307)",
    fill: "#5ec5c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M956.579,617.218c2.853,2.109,14.95,3.063,14.95,3.063s-4.453-11.285-7.306-13.4a6.427,6.427,0,1,0-7.644,10.334Z",
    transform: "translate(-953.974 -520.954)",
    fill: "#017572"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(-220.041 150.312)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M899.79,599.387s5.557-18.858-1.044-32.746a29.793,29.793,0,0,1-2.41-18.69,50.117,50.117,0,0,1,2.644-8.771",
    transform: "translate(-886.116 -524.398)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M892.72,512.421c0,2.313,4.191,9.014,4.191,9.014s4.191-6.705,4.191-9.014a4.191,4.191,0,1,0-8.381,0Z",
    transform: "translate(-883.957 -508.23)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M909.93,539.6c1.257,1.94,8.415,5.293,8.415,5.293s-.13-7.9-1.387-9.844a4.191,4.191,0,1,0-7.028,4.551Z",
    transform: "translate(-908.086 -522.41)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M906.945,590.125c2.066,1.039,9.936.323,9.936.323s-4.1-6.755-6.164-7.795a4.191,4.191,0,0,0-3.771,7.476Z",
    transform: "translate(-904.8 -550.679)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M897.358,630.083c1.861,1.375,9.739,1.995,9.739,1.995s-2.9-7.35-4.76-8.725a4.191,4.191,0,0,0-4.979,6.73Z",
    transform: "translate(-891.252 -572.887)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M894.185,552.334c-1.676,1.609-9.383,3.281-9.383,3.281s1.89-7.673,3.549-9.282a4.191,4.191,0,1,1,5.833,6.005Z",
    transform: "translate(-875.139 -529.313)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M882.537,597.815c-2.066,1.039-9.936.323-9.936.323s4.1-6.755,6.164-7.795a4.191,4.191,0,0,1,3.772,7.476Z",
    transform: "translate(-859.107 -555.08)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M879.716,644.659c-1.861,1.375-9.739,1.995-9.739,1.995s2.917-7.355,4.761-8.729a4.191,4.191,0,0,1,4.978,6.734Z",
    transform: "translate(-854.61 -581.34)",
    fill: "#017572"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(-127.059 147.607)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46-2",
    "data-name": "Path 46",
    d: "M1006.741,486.1s5.767-19.579-1.082-33.99a30.917,30.917,0,0,1-2.5-19.4,52.019,52.019,0,0,1,2.747-9.116",
    transform: "translate(-992.383 -408.403)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47-2",
    "data-name": "Path 47",
    d: "M996.9,370.106c0,2.4,4.345,9.35,4.345,9.35s4.346-6.959,4.346-9.35a4.346,4.346,0,1,0-8.689,0Z",
    transform: "translate(-987.645 -365.66)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48-2",
    "data-name": "Path 48",
    d: "M1028.208,419.248c1.3,2.015,8.733,5.493,8.733,5.493s-.136-8.2-1.44-10.217a4.346,4.346,0,1,0-7.293,4.722Z",
    transform: "translate(-1026.129 -401.289)",
    fill: "#5ec5c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49-2",
    "data-name": "Path 49",
    d: "M1021.752,511.747c2.144,1.08,10.311.334,10.311.334s-4.257-7.013-6.4-8.093a4.345,4.345,0,1,0-3.913,7.759Z",
    transform: "translate(-1019.36 -470.665)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50-2",
    "data-name": "Path 50",
    d: "M1004.422,586.3c1.929,1.426,10.108,2.071,10.108,2.071s-3.011-7.63-4.939-9.058a4.345,4.345,0,1,0-5.168,6.987Z",
    transform: "translate(-997.922 -527.701)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51-2",
    "data-name": "Path 51",
    d: "M992.524,442.536c-1.72,1.671-9.741,3.4-9.741,3.4s1.964-7.964,3.684-9.638a4.346,4.346,0,1,1,6.057,6.234Z",
    transform: "translate(-972.588 -418.529)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52-2",
    "data-name": "Path 52",
    d: "M969.5,526.2c-2.143,1.08-10.311.334-10.311.334s4.257-7.013,6.4-8.093A4.346,4.346,0,0,1,969.5,526.2Z",
    transform: "translate(-945.027 -481.705)",
    fill: "#5ec5c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53-2",
    "data-name": "Path 53",
    d: "M964.081,613.463c-1.929,1.426-10.107,2.071-10.107,2.071s3.011-7.63,4.939-9.058a4.345,4.345,0,1,1,5.168,6.987Z",
    transform: "translate(-937.856 -548.378)",
    fill: "#017572"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17880",
    "data-name": "Group 17880",
    transform: "translate(-717.442 37.537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27-3",
    "data-name": "Path 27",
    d: "M15.819,86.454V64.233H29.177V86.454H45V52.081H56.6V26.388h9.491V0H85.775V26.388h9.492V52.081h11.249v-30.9h6.328V5.555h3.867V21.179h22.5v98.606h17.225V109.369h10.546v10.416H184.2V86.454H215.14V64.233H228.5V86.454h.7V129.16h14.061v-25h16.874v25H274.2V52.081h10.9V26.388H325.17V52.081h10.546V187.837H0V86.454Z",
    transform: "translate(0)",
    fill: "#1ab1e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15-3",
    "data-name": "Rectangle 15",
    width: 14.669,
    height: 8.382,
    transform: "translate(314.411 61.285)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16-3",
    "data-name": "Rectangle 16",
    width: 14.669,
    height: 8.382,
    transform: "translate(281.07 61.285)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17-3",
    "data-name": "Rectangle 17",
    width: 14.669,
    height: 8.382,
    transform: "translate(314.411 77.935)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18-3",
    "data-name": "Rectangle 18",
    width: 14.669,
    height: 8.382,
    transform: "translate(281.07 77.935)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19-3",
    "data-name": "Rectangle 19",
    width: 14.669,
    height: 8.382,
    transform: "translate(314.411 94.585)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20-3",
    "data-name": "Rectangle 20",
    width: 14.669,
    height: 8.382,
    transform: "translate(281.07 94.585)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21-3",
    "data-name": "Rectangle 21",
    width: 14.669,
    height: 8.382,
    transform: "translate(314.411 111.234)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22-3",
    "data-name": "Rectangle 22",
    width: 14.669,
    height: 8.382,
    transform: "translate(281.07 111.234)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23-3",
    "data-name": "Rectangle 23",
    width: 14.669,
    height: 8.382,
    transform: "translate(314.411 127.884)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24-3",
    "data-name": "Rectangle 24",
    width: 14.669,
    height: 8.382,
    transform: "translate(281.07 127.884)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25-3",
    "data-name": "Rectangle 25",
    width: 14.669,
    height: 8.382,
    transform: "translate(314.411 144.534)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26-3",
    "data-name": "Rectangle 26",
    width: 14.669,
    height: 8.382,
    transform: "translate(281.07 144.534)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27-3",
    "data-name": "Rectangle 27",
    width: 14.669,
    height: 8.382,
    transform: "translate(314.411 161.07)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28-3",
    "data-name": "Rectangle 28",
    width: 14.669,
    height: 8.382,
    transform: "translate(281.07 161.07)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29-3",
    "data-name": "Rectangle 29",
    width: 34.228,
    height: 4.191,
    transform: "translate(234.42 140.249)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30-3",
    "data-name": "Rectangle 30",
    width: 34.228,
    height: 4.191,
    transform: "translate(234.42 146.624)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31-3",
    "data-name": "Rectangle 31",
    width: 34.228,
    height: 4.191,
    transform: "translate(234.42 152.812)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32-3",
    "data-name": "Rectangle 32",
    width: 34.228,
    height: 4.191,
    transform: "translate(144.448 142.374)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33-3",
    "data-name": "Rectangle 33",
    width: 34.228,
    height: 4.191,
    transform: "translate(144.448 148.749)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34-3",
    "data-name": "Rectangle 34",
    width: 34.228,
    height: 4.191,
    transform: "translate(144.448 154.95)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35-3",
    "data-name": "Rectangle 35",
    width: 34.228,
    height: 4.191,
    transform: "translate(234.42 159.226)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36-3",
    "data-name": "Rectangle 36",
    width: 34.228,
    height: 4.191,
    transform: "translate(234.42 165.639)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37-3",
    "data-name": "Rectangle 37",
    width: 34.228,
    height: 4.191,
    transform: "translate(234.42 172.053)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38-3",
    "data-name": "Rectangle 38",
    width: 9.43,
    height: 12.224,
    transform: "translate(212.19 96.379)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39-3",
    "data-name": "Rectangle 39",
    width: 9.43,
    height: 12.224,
    transform: "translate(191.463 96.379)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40-3",
    "data-name": "Rectangle 40",
    width: 9.43,
    height: 12.224,
    transform: "translate(212.19 116.221)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41-3",
    "data-name": "Rectangle 41",
    width: 9.43,
    height: 12.224,
    transform: "translate(191.463 116.221)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42-3",
    "data-name": "Rectangle 42",
    width: 9.43,
    height: 12.224,
    transform: "translate(212.19 136.064)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43-3",
    "data-name": "Rectangle 43",
    width: 9.43,
    height: 12.224,
    transform: "translate(191.463 136.064)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44-3",
    "data-name": "Rectangle 44",
    width: 9.43,
    height: 12.224,
    transform: "translate(212.19 155.781)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45-3",
    "data-name": "Rectangle 45",
    width: 9.43,
    height: 12.224,
    transform: "translate(191.463 155.781)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46-3",
    "data-name": "Rectangle 46",
    width: 12.574,
    height: 16.066,
    transform: "translate(126.477 29.149)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47-3",
    "data-name": "Rectangle 47",
    width: 12.574,
    height: 16.066,
    transform: "translate(126.477 53.163)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48-3",
    "data-name": "Rectangle 48",
    width: 12.574,
    height: 16.066,
    transform: "translate(126.477 76.554)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49-3",
    "data-name": "Rectangle 49",
    width: 12.574,
    height: 16.066,
    transform: "translate(126.477 99.946)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50-3",
    "data-name": "Rectangle 50",
    width: 12.574,
    height: 16.066,
    transform: "translate(126.477 123.337)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51-3",
    "data-name": "Rectangle 51",
    width: 12.574,
    height: 16.066,
    transform: "translate(126.477 146.566)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52-3",
    "data-name": "Rectangle 52",
    width: 46.802,
    height: 13.622,
    transform: "translate(51.867 63.077)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53-3",
    "data-name": "Rectangle 53",
    width: 46.802,
    height: 13.622,
    transform: "translate(51.692 92.843)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54-3",
    "data-name": "Rectangle 54",
    width: 46.802,
    height: 13.622,
    transform: "translate(51.517 122.61)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55-3",
    "data-name": "Rectangle 55",
    width: 46.802,
    height: 13.622,
    transform: "translate(51.343 152.236)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56-3",
    "data-name": "Rectangle 56",
    width: 6.287,
    height: 13.272,
    transform: "translate(318.951 34.373)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57-3",
    "data-name": "Rectangle 57",
    width: 15.717,
    height: 20.258,
    transform: "translate(0 96.428)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58-3",
    "data-name": "Rectangle 58",
    width: 15.717,
    height: 20.258,
    transform: "translate(0 126.207)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59-3",
    "data-name": "Rectangle 59",
    width: 15.717,
    height: 20.258,
    transform: "translate(0 155.909)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28-3",
    "data-name": "Path 28",
    d: "M318.541,151.16h2.4a1.683,1.683,0,1,1,0-3.363h19.465a1.683,1.683,0,0,1,0,3.363h-2.4a1.683,1.683,0,1,1,0,3.363h3.363a1.683,1.683,0,1,1,0,3.363H321.9a1.683,1.683,0,1,1,0-3.363h-3.363a1.683,1.683,0,1,1,0-3.363Z",
    transform: "translate(-75.969 -134.507)",
    fill: "#ebfaff",
    opacity: 0.247
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29-4",
    "data-name": "Path 29",
    d: "M564.541,272.16h2.4a1.683,1.683,0,1,1,0-3.363h19.465a1.683,1.683,0,0,1,0,3.363h-2.4a1.683,1.683,0,1,1,0,3.363h3.363a1.683,1.683,0,1,1,0,3.363H567.9a1.683,1.683,0,1,1,0-3.363h-3.364a1.683,1.683,0,1,1,0-3.363Z",
    transform: "translate(-408.415 -212.447)",
    fill: "#ebfaff",
    opacity: 0.247
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30-4",
    "data-name": "Path 30",
    d: "M983.541,114.16h2.4a1.683,1.683,0,1,1,0-3.363h19.465a1.683,1.683,0,0,1,0,3.363h-2.4a1.683,1.683,0,1,1,0,3.363h3.364a1.683,1.683,0,1,1,0,3.363H986.9a1.683,1.683,0,0,1,0-3.363h-3.363a1.683,1.683,0,1,1,0-3.363Z",
    transform: "translate(-974.697 -110.43)",
    fill: "#ebfaff",
    opacity: 0.247
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31-4",
    "data-name": "Path 31",
    d: "M518.88,465.94l.416.3A1.767,1.767,0,0,1,518.88,465.94Z",
    transform: "translate(-323.077 -339.818)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32-4",
    "data-name": "Path 32",
    d: "M519.81,466.88c.269.2.416.3.416.3A1.772,1.772,0,0,1,519.81,466.88Z",
    transform: "translate(-324.334 -340.426)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33-4",
    "data-name": "Path 33",
    d: "M519.81,465.94l.416.3A1.769,1.769,0,0,1,519.81,465.94Z",
    transform: "translate(-324.334 -339.818)",
    fill: "#ebfaff",
    opacity: 0.253
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17881",
    "data-name": "Group 17881",
    transform: "translate(-1112.398 4.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27-4",
    "data-name": "Path 27",
    d: "M18.611,101.709V75.567H34.326v26.142H52.937V61.271H66.584V31.044H77.751V0h23.16V31.044h11.166V61.271h13.234V24.917h7.444V6.536H137.3V24.917h26.468V140.923h20.265V128.668h12.407v12.254h20.265V101.709H253.1V75.567h15.716v26.142h.827v50.242h16.543v-29.41H306.04v29.41h16.543V61.271H335.4V31.044h47.147V61.271h12.407V220.983H0V101.709Z",
    transform: "translate(0)",
    fill: "#1ab1e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15-4",
    "data-name": "Rectangle 15",
    width: 17.258,
    height: 9.862,
    transform: "translate(369.891 72.099)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16-4",
    "data-name": "Rectangle 16",
    width: 17.258,
    height: 9.862,
    transform: "translate(330.668 72.1)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17-4",
    "data-name": "Rectangle 17",
    width: 17.258,
    height: 9.862,
    transform: "translate(369.891 91.687)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18-4",
    "data-name": "Rectangle 18",
    width: 17.258,
    height: 9.862,
    transform: "translate(330.668 91.687)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19-4",
    "data-name": "Rectangle 19",
    width: 17.258,
    height: 9.862,
    transform: "translate(369.891 111.275)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20-4",
    "data-name": "Rectangle 20",
    width: 17.258,
    height: 9.862,
    transform: "translate(330.668 111.275)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21-4",
    "data-name": "Rectangle 21",
    width: 17.258,
    height: 9.862,
    transform: "translate(369.891 130.863)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22-4",
    "data-name": "Rectangle 22",
    width: 17.258,
    height: 9.862,
    transform: "translate(330.668 130.863)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23-4",
    "data-name": "Rectangle 23",
    width: 17.258,
    height: 9.862,
    transform: "translate(369.891 150.451)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24-4",
    "data-name": "Rectangle 24",
    width: 17.258,
    height: 9.862,
    transform: "translate(330.668 150.451)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25-4",
    "data-name": "Rectangle 25",
    width: 17.258,
    height: 9.862,
    transform: "translate(369.891 170.038)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26-4",
    "data-name": "Rectangle 26",
    width: 17.258,
    height: 9.862,
    transform: "translate(330.668 170.038)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27-4",
    "data-name": "Rectangle 27",
    width: 17.258,
    height: 9.862,
    transform: "translate(369.891 189.492)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28-4",
    "data-name": "Rectangle 28",
    width: 17.258,
    height: 9.862,
    transform: "translate(330.668 189.492)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29-4",
    "data-name": "Rectangle 29",
    width: 40.268,
    height: 4.931,
    transform: "translate(275.786 164.997)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30-4",
    "data-name": "Rectangle 30",
    width: 40.268,
    height: 4.931,
    transform: "translate(275.786 172.497)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31-4",
    "data-name": "Rectangle 31",
    width: 40.268,
    height: 4.931,
    transform: "translate(275.786 179.777)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32-4",
    "data-name": "Rectangle 32",
    width: 40.268,
    height: 4.931,
    transform: "translate(169.937 167.497)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33-4",
    "data-name": "Rectangle 33",
    width: 40.268,
    height: 4.931,
    transform: "translate(169.937 174.997)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34-4",
    "data-name": "Rectangle 34",
    width: 40.268,
    height: 4.931,
    transform: "translate(169.937 182.292)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35-4",
    "data-name": "Rectangle 35",
    width: 40.268,
    height: 4.931,
    transform: "translate(275.786 187.322)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36-4",
    "data-name": "Rectangle 36",
    width: 40.268,
    height: 4.931,
    transform: "translate(275.786 194.868)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37-4",
    "data-name": "Rectangle 37",
    width: 40.268,
    height: 4.931,
    transform: "translate(275.786 202.413)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38-4",
    "data-name": "Rectangle 38",
    width: 11.094,
    height: 14.382,
    transform: "translate(249.633 113.385)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39-4",
    "data-name": "Rectangle 39",
    width: 11.094,
    height: 14.382,
    transform: "translate(225.249 113.385)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40-4",
    "data-name": "Rectangle 40",
    width: 11.094,
    height: 14.382,
    transform: "translate(249.633 136.729)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41-4",
    "data-name": "Rectangle 41",
    width: 11.094,
    height: 14.382,
    transform: "translate(225.249 136.729)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42-4",
    "data-name": "Rectangle 42",
    width: 11.094,
    height: 14.382,
    transform: "translate(249.633 160.073)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43-4",
    "data-name": "Rectangle 43",
    width: 11.094,
    height: 14.382,
    transform: "translate(225.249 160.073)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44-4",
    "data-name": "Rectangle 44",
    width: 11.094,
    height: 14.382,
    transform: "translate(249.633 183.27)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45-4",
    "data-name": "Rectangle 45",
    width: 11.094,
    height: 14.382,
    transform: "translate(225.249 183.27)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46-4",
    "data-name": "Rectangle 46",
    width: 14.792,
    height: 18.901,
    transform: "translate(148.795 34.293)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47-4",
    "data-name": "Rectangle 47",
    width: 14.792,
    height: 18.901,
    transform: "translate(148.795 62.544)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48-4",
    "data-name": "Rectangle 48",
    width: 14.792,
    height: 18.901,
    transform: "translate(148.795 90.063)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49-4",
    "data-name": "Rectangle 49",
    width: 14.792,
    height: 18.901,
    transform: "translate(148.795 117.582)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50-4",
    "data-name": "Rectangle 50",
    width: 14.792,
    height: 18.901,
    transform: "translate(148.795 145.101)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51-4",
    "data-name": "Rectangle 51",
    width: 14.792,
    height: 18.901,
    transform: "translate(148.795 172.429)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52-4",
    "data-name": "Rectangle 52",
    width: 55.061,
    height: 16.025,
    transform: "translate(61.019 74.207)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53-4",
    "data-name": "Rectangle 53",
    width: 55.061,
    height: 16.025,
    transform: "translate(60.814 109.226)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54-4",
    "data-name": "Rectangle 54",
    width: 55.061,
    height: 16.025,
    transform: "translate(60.608 144.245)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55-4",
    "data-name": "Rectangle 55",
    width: 55.061,
    height: 16.025,
    transform: "translate(60.402 179.1)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56-4",
    "data-name": "Rectangle 56",
    width: 7.396,
    height: 15.614,
    transform: "translate(375.233 40.438)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57-4",
    "data-name": "Rectangle 57",
    width: 18.491,
    height: 23.832,
    transform: "translate(0 113.443)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58-4",
    "data-name": "Rectangle 58",
    width: 18.491,
    height: 23.832,
    transform: "translate(0 148.477)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59-4",
    "data-name": "Rectangle 59",
    width: 18.491,
    height: 23.832,
    transform: "translate(0 183.42)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28-4",
    "data-name": "Path 28",
    d: "M318.851,151.754h2.827a1.981,1.981,0,1,1,0-3.957h22.9a1.981,1.981,0,0,1,0,3.957h-2.827a1.981,1.981,0,1,1,0,3.957h3.957a1.981,1.981,0,1,1,0,3.957h-22.9a1.981,1.981,0,1,1,0-3.957h-3.957a1.981,1.981,0,1,1,0-3.957Z",
    transform: "translate(-33.475 -132.162)",
    fill: "#ebfaff",
    opacity: 0.247
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29-5",
    "data-name": "Path 29",
    d: "M564.851,272.754h2.827a1.981,1.981,0,1,1,0-3.957h22.9a1.981,1.981,0,0,1,0,3.957h-2.827a1.981,1.981,0,1,1,0,3.957h3.957a1.981,1.981,0,1,1,0,3.957h-22.9a1.981,1.981,0,1,1,0-3.957h-3.957a1.981,1.981,0,1,1,0-3.957Z",
    transform: "translate(-381.175 -202.504)",
    fill: "#ebfaff",
    opacity: 0.247
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30-5",
    "data-name": "Path 30",
    d: "M983.851,114.754h2.827a1.981,1.981,0,1,1,0-3.957h22.9a1.981,1.981,0,0,1,0,3.957h-2.827a1.981,1.981,0,1,1,0,3.957h3.957a1.981,1.981,0,1,1,0,3.957h-22.9a1.981,1.981,0,0,1,0-3.957h-3.957a1.981,1.981,0,1,1,0-3.957Z",
    transform: "translate(-973.447 -110.366)",
    fill: "#ebfaff",
    opacity: 0.247
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31-5",
    "data-name": "Path 31",
    d: "M518.88,465.94c.316.23.489.357.489.357A2.081,2.081,0,0,1,518.88,465.94Z",
    transform: "translate(-288.526 -317.563)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32-5",
    "data-name": "Path 32",
    d: "M519.81,466.88c.316.23.489.357.489.357A2.088,2.088,0,0,1,519.81,466.88Z",
    transform: "translate(-289.84 -318.112)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33-5",
    "data-name": "Path 33",
    d: "M519.81,465.94c.316.23.489.357.489.357A2.085,2.085,0,0,1,519.81,465.94Z",
    transform: "translate(-289.84 -317.563)",
    fill: "#ebfaff",
    opacity: 0.253
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17882",
    "data-name": "Group 17882",
    transform: "translate(-1261.001 171.542)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29-6",
    "data-name": "Path 29",
    d: "M154.306,583.635s-12.758,7.7,10.76,19.549c0,0,5.186-9.62-.548-17.463a7.724,7.724,0,0,0-10.02-2.2Z",
    transform: "translate(-150.851 -549.834)",
    fill: "#01a09b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30-6",
    "data-name": "Path 30",
    d: "M173.08,588.3S184,596.654,183.693,608.01",
    transform: "translate(-169.297 -554.661)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31-6",
    "data-name": "Path 31",
    d: "M234.092,488.555s-4-13.574.75-23.564a21.434,21.434,0,0,0,1.734-13.45,36.057,36.057,0,0,0-1.9-6.32",
    transform: "translate(-219.054 -434.767)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32-6",
    "data-name": "Path 32",
    d: "M232.841,390.371c0,1.664-3.013,6.482-3.013,6.482s-3.013-4.824-3.013-6.482a3.013,3.013,0,1,1,6.023,0Z",
    transform: "translate(-214.278 -387.289)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33-6",
    "data-name": "Path 33",
    d: "M263.454,439.447c-.9,1.4-6.054,3.808-6.054,3.808s.094-5.686,1-7.083a3.013,3.013,0,0,1,5.056,3.273Z",
    transform: "translate(-239.877 -426.996)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34-2",
    "data-name": "Path 34",
    d: "M256.448,530.854c-1.486.749-7.148.232-7.148.232s2.951-4.862,4.437-5.61a3.012,3.012,0,1,1,2.713,5.379Z",
    transform: "translate(-233.094 -502.376)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35-2",
    "data-name": "Path 35",
    d: "M239.607,605.528c-1.337.989-7.007,1.436-7.007,1.436s2.087-5.289,3.424-6.28a3.013,3.013,0,1,1,3.583,4.844Z",
    transform: "translate(-219.117 -564.904)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36-2",
    "data-name": "Path 36",
    d: "M213.385,461.645c1.193,1.159,6.753,2.359,6.753,2.359s-1.361-5.521-2.554-6.681a3.013,3.013,0,1,0-4.2,4.32Z",
    transform: "translate(-202.228 -444.998)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37-2",
    "data-name": "Path 37",
    d: "M190.334,545.144c1.486.749,7.148.232,7.148.232s-2.951-4.862-4.437-5.61a3.012,3.012,0,1,0-2.713,5.379Z",
    transform: "translate(-182.353 -514.301)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38-2",
    "data-name": "Path 38",
    d: "M185.137,632.689c1.337.988,7.007,1.436,7.007,1.436s-2.087-5.291-3.426-6.28a3.013,3.013,0,1,0-3.583,4.844Z",
    transform: "translate(-178.368 -587.302)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39-2",
    "data-name": "Path 39",
    d: "M232.841,390.371c0,1.664-3.013,6.482-3.013,6.482s-3.013-4.824-3.013-6.482a3.013,3.013,0,1,1,6.023,0Z",
    transform: "translate(-214.278 -387.289)",
    fill: "#93d502",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40-2",
    "data-name": "Path 40",
    d: "M263.454,439.447c-.9,1.4-6.054,3.808-6.054,3.808s.094-5.686,1-7.083a3.013,3.013,0,0,1,5.056,3.273Z",
    transform: "translate(-239.877 -426.996)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41-2",
    "data-name": "Path 41",
    d: "M256.448,530.854c-1.486.749-7.148.232-7.148.232s2.951-4.862,4.437-5.61a3.012,3.012,0,1,1,2.713,5.379Z",
    transform: "translate(-233.094 -502.376)",
    fill: "#93d502",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42-2",
    "data-name": "Path 42",
    d: "M239.607,605.528c-1.337.989-7.007,1.436-7.007,1.436s2.087-5.289,3.424-6.28a3.013,3.013,0,1,1,3.583,4.844Z",
    transform: "translate(-219.117 -564.904)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43-2",
    "data-name": "Path 43",
    d: "M213.385,461.645c1.193,1.159,6.753,2.359,6.753,2.359s-1.361-5.521-2.554-6.681a3.013,3.013,0,1,0-4.2,4.32Z",
    transform: "translate(-202.228 -444.998)",
    fill: "#5ec5c1",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44-2",
    "data-name": "Path 44",
    d: "M190.334,545.144c1.486.749,7.148.232,7.148.232s-2.951-4.862-4.437-5.61a3.012,3.012,0,1,0-2.713,5.379Z",
    transform: "translate(-182.353 -514.301)",
    fill: "#93d502",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45-2",
    "data-name": "Path 45",
    d: "M185.137,632.689c1.337.988,7.007,1.436,7.007,1.436s-2.087-5.291-3.426-6.28a3.013,3.013,0,1,0-3.583,4.844Z",
    transform: "translate(-178.368 -587.302)",
    opacity: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17883",
    "data-name": "Group 17883",
    transform: "translate(-1196.327 153.407)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46-3",
    "data-name": "Path 46",
    d: "M1004.67,481.453s-5.338-18.124,1-31.464a28.621,28.621,0,0,0,2.315-17.96,48.144,48.144,0,0,0-2.542-8.439",
    transform: "translate(-992.053 -409.531)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47-3",
    "data-name": "Path 47",
    d: "M1004.951,369.776c0,2.222-4.023,8.655-4.023,8.655s-4.023-6.442-4.023-8.655a4.023,4.023,0,1,1,8.043,0Z",
    transform: "translate(-987.615 -365.66)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48-3",
    "data-name": "Path 48",
    d: "M1035.534,418.743c-1.207,1.865-8.084,5.085-8.084,5.085s.126-7.593,1.333-9.458a4.023,4.023,0,1,1,6.751,4.371Z",
    transform: "translate(-1011.551 -402.118)",
    fill: "#5ec5c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49-3",
    "data-name": "Path 49",
    d: "M1028.9,511.136c-1.984,1-9.545.309-9.545.309s3.94-6.492,5.925-7.491a4.022,4.022,0,1,1,3.623,7.183Z",
    transform: "translate(-1005.211 -473.106)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50-3",
    "data-name": "Path 50",
    d: "M1012.016,585.721c-1.785,1.32-9.356,1.917-9.356,1.917s2.787-7.063,4.572-8.385a4.023,4.023,0,1,1,4.784,6.468Z",
    transform: "translate(-992.125 -531.473)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51-3",
    "data-name": "Path 51",
    d: "M984,441.982c1.593,1.547,9.017,3.151,9.017,3.151s-1.818-7.372-3.41-8.922A4.023,4.023,0,1,0,984,441.982Z",
    transform: "translate(-976.549 -419.758)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52-3",
    "data-name": "Path 52",
    d: "M961.314,525.591c1.984,1,9.545.309,9.545.309s-3.94-6.492-5.925-7.491a4.023,4.023,0,0,0-3.62,7.182Z",
    transform: "translate(-958.062 -484.404)",
    fill: "#5ec5c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53-3",
    "data-name": "Path 53",
    d: "M955.6,612.881c1.785,1.32,9.357,1.917,9.357,1.917s-2.787-7.063-4.572-8.385a4.023,4.023,0,0,0-4.784,6.468Z",
    transform: "translate(-953.974 -552.632)",
    fill: "#017572"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17884",
    "data-name": "Group 17884",
    transform: "translate(-1270.391 178.395)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54-2",
    "data-name": "Path 54",
    d: "M898.29,576.862s3.478-11.8-.653-20.495a18.646,18.646,0,0,1-1.508-11.7,31.355,31.355,0,0,1,1.655-5.49",
    transform: "translate(-889.732 -529.928)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55-2",
    "data-name": "Path 55",
    d: "M892.72,510.853c0,1.448,2.623,5.642,2.623,5.642s2.623-4.2,2.623-5.642a2.623,2.623,0,1,0-5.246,0Z",
    transform: "translate(-887.236 -508.23)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56-2",
    "data-name": "Path 56",
    d: "M909.638,537.125c.787,1.214,5.266,3.313,5.266,3.313s-.081-4.947-.868-6.161a2.623,2.623,0,1,0-4.4,2.848Z",
    transform: "translate(-908.484 -526.364)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57-2",
    "data-name": "Path 57",
    d: "M906.143,587.19c1.293.65,6.219.2,6.219.2s-2.568-4.228-3.858-4.878a2.623,2.623,0,0,0-2.361,4.679Z",
    transform: "translate(-904.8 -562.502)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58-2",
    "data-name": "Path 58",
    d: "M896.782,627.3c1.165.86,6.1,1.248,6.1,1.248s-1.815-4.6-2.979-5.461a2.623,2.623,0,0,0-3.116,4.212Z",
    transform: "translate(-892.961 -591.504)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59-2",
    "data-name": "Path 59",
    d: "M890.675,549.592c-1.049,1.007-5.872,2.054-5.872,2.054s1.183-4.8,2.221-5.809a2.623,2.623,0,1,1,3.651,3.759Z",
    transform: "translate(-878.754 -535.184)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60-2",
    "data-name": "Path 60",
    d: "M878.819,594.881c-1.293.65-6.219.2-6.219.2s2.568-4.228,3.858-4.878a2.623,2.623,0,0,1,2.361,4.679Z",
    transform: "translate(-864.155 -568.134)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61-2",
    "data-name": "Path 61",
    d: "M876.072,641.868c-1.165.86-6.1,1.248-6.1,1.248s1.825-4.6,2.979-5.463a2.623,2.623,0,0,1,3.116,4.215Z",
    transform: "translate(-860.359 -602.239)",
    fill: "#017572"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17885",
    "data-name": "Group 17885",
    transform: "translate(-1212.196 176.702)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46-4",
    "data-name": "Path 46",
    d: "M1005.18,462.712s3.609-12.254-.677-21.273a19.35,19.35,0,0,1-1.565-12.143,32.553,32.553,0,0,1,1.719-5.706",
    transform: "translate(-996.193 -414.085)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47-4",
    "data-name": "Path 47",
    d: "M996.9,368.443c0,1.5,2.72,5.852,2.72,5.852s2.72-4.355,2.72-5.852a2.72,2.72,0,1,0-5.438,0Z",
    transform: "translate(-991.109 -365.66)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48-4",
    "data-name": "Path 48",
    d: "M1027.925,416.7c.816,1.261,5.466,3.438,5.466,3.438s-.085-5.134-.9-6.395a2.72,2.72,0,1,0-4.565,2.955Z",
    transform: "translate(-1026.623 -405.464)",
    fill: "#5ec5c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49-4",
    "data-name": "Path 49",
    d: "M1020.857,508.67c1.341.676,6.453.209,6.453.209s-2.664-4.389-4.006-5.065a2.719,2.719,0,1,0-2.449,4.856Z",
    transform: "translate(-1019.36 -482.958)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50-4",
    "data-name": "Path 50",
    d: "M1003.762,583.37c1.207.892,6.326,1.3,6.326,1.3S1008.2,579.891,1007,579a2.72,2.72,0,1,0-3.235,4.373Z",
    transform: "translate(-999.695 -546.693)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51-4",
    "data-name": "Path 51",
    d: "M988.879,439.744c-1.077,1.046-6.1,2.13-6.1,2.13s1.229-4.984,2.306-6.032a2.72,2.72,0,1,1,3.791,3.9Z",
    transform: "translate(-976.402 -424.719)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52-4",
    "data-name": "Path 52",
    d: "M965.645,523.14c-1.342.676-6.453.209-6.453.209s2.664-4.389,4.006-5.065a2.72,2.72,0,0,1,2.448,4.856Z",
    transform: "translate(-950.327 -495.293)",
    fill: "#5ec5c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53-4",
    "data-name": "Path 53",
    d: "M960.3,610.53c-1.207.892-6.326,1.3-6.326,1.3s1.884-4.775,3.091-5.669a2.72,2.72,0,0,1,3.235,4.373Z",
    transform: "translate(-943.886 -569.796)",
    fill: "#017572"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterSectionBuilding);
export default __webpack_public_path__ + "static/media/register_section_building.5455b21cdfb5fc67fc064465ad9cd4f3.svg";
export { ForwardRef as ReactComponent };